export enum SoftwareEscrowOnboardingRoutesEnum {
  Members = 'members',
  Depositor = 'depositor',
  Beneficiary = 'beneficiary',
  NotificationSettings = 'notification-settings',
  ActivationNotifications = 'activation-notifications',
  AssetVisibility = 'asset-visibility',
  StorageSettings = 'storage-settings',
  AgreementSetup = 'agreement-setup',
  AgreementDetails = 'agreement-details',
  Summary = 'summary',
}
